import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'
import {getAuthModel} from '../../auth'
import {mediasApi} from './apiMediaSlice'

const API3_URL: string | undefined = process.env.REACT_APP_API3_URL

export const mediaS3Api = createApi({
  reducerPath: 'mediaS3Api',
  baseQuery: fetchBaseQuery({
    baseUrl: `${API3_URL}`,
    prepareHeaders: (headers) => {
      const auth = getAuthModel()
      if (auth?.access_token) {
                headers.set('authorization', `Bearer ${auth.access_token}`)
            }
      return headers
    },
  }),
  endpoints: (builder) => ({
    getPresignedUrl: builder.mutation<
      {url: string; key: string; fields?: Record<string, string>},
      {file_name: string; file_type: string; file_size: number; source_group_id: string}
    >({
      query: (params) => ({
        url: 'source/presigned-url',
        method: 'POST',
        body: params,
      }),
    }),
    confirmS3Upload: builder.mutation<any, any>({
      query: (data) => ({
        url: 'source/confirm-upload',
        method: 'POST',
        body: data,
      }),
      async onQueryStarted(_args, {dispatch, queryFulfilled}) {
        await queryFulfilled
        setTimeout(() => {
          dispatch(mediasApi.util.invalidateTags(['Medias', 'Media']))
        }, 3000)
      },
    }),
  }),
})

export const {useGetPresignedUrlMutation, useConfirmS3UploadMutation} = mediaS3Api
